module.exports = __webpack_public_path__ + "bdb91e7ecc920ee23c3303f8de324ed9.png";